import { Dropdown } from '@carbon/react';
import styles from './sort-order.module.scss';

export type SortOption = {
  id: string;
  text: string;
  sort_by: 'created_at' | 'updated_at';
  sort_order: 'desc' | 'asc';
};

const sortOptions: SortOption[] = [
  {
    id: 'created-newest',
    text: 'Created At - Newest',
    sort_by: 'created_at',
    sort_order: 'desc',
  },
  {
    id: 'created-oldest',
    text: 'Created At - Oldest',
    sort_by: 'created_at',
    sort_order: 'asc',
  },
  {
    id: 'updated-newest',
    text: 'Updated At - Newest',
    sort_by: 'updated_at',
    sort_order: 'desc',
  },
  {
    id: 'updated-oldest',
    text: 'Updated At - Oldest',
    sort_by: 'updated_at',
    sort_order: 'asc',
  },
];

interface SortOrderProps {
  onChange: (option: SortOption) => void;
  value?: string;
}

const SortOrder = ({ onChange, value = 'created-newest' }: SortOrderProps) => {
  return (
    <div className={styles.sortOrderContainer}>
      <h1 className={styles.heading}>Sort Order</h1>
      <div className={styles.contentWrapper}>
        <Dropdown
          size="lg"
          id="sort-order"
          titleText=""
          label="Sort Order"
          items={sortOptions}
          itemToString={(item) => item?.text || ''}
          selectedItem={sortOptions.find((option) => option.id === value)}
          onChange={({ selectedItem }) => {
            if (selectedItem) {
              onChange(selectedItem);
            }
          }}
        />
      </div>
    </div>
  );
};

export default SortOrder;
export { sortOptions };
